import angular = require("angular");
import TPL = require("templates");
import {EventData} from "../../models/contracts";
import {SessionService} from "../../services/session";
import _ = require("lodash");

/**
  Directive to show a iconed list of details, both horizontal or vertical

  params:
    type: 'horizontal' | 'vertical' defaults to 'vertical'

    one of:

      event: EventData

    or,

      items: array of {
        visible: boolean, if it has to be shown
        icon: string, name of gliphicon
        text: string, text
        class: additional classes
      }
*/
export class InfoDirective {

  template = TPL.contentDirectives.info;
  scope = {
    params: "=params"
  };
  link;

  constructor($filter, session) {

    var availableCities = session.getAvailableCities();

    this.link = (scope, el, attrs) => {
        var dateFilter = $filter("date");
        var translateFilter = $filter("translate");

        scope.vm = {
          infoParams: {
            items: [{visible: true}, {visible: true}, {visible: true}, {visible: true}]
          },
          getData() {
            if (scope.params.items) {
              return scope.params.items;
            }

            return scope.vm.getInfoParams(scope.params.event);
          },
          getInfoParams: (event: EventData) => {

            if (event) {
              scope.vm.infoParams.items[0].icon = "icon-calendar ot-grey-icon";
              scope.vm.infoParams.items[0].text = scope.vm.buildPrettyDate(event.event_date);
              if (scope.vm.isNear(event.event_date)) {
                scope.vm.infoParams.items[0].class = "ot-hilight";
              }

              scope.vm.infoParams.items[1].icon = "icon-clock ot-grey-icon";
              scope.vm.infoParams.items[1].text = scope.vm.buildPrettyHours(event.event_date, event.event_time, event.duration);

              scope.vm.infoParams.items[2].icon = "icon-marker ot-grey-icon";

              var locationLabel = "";

              if (event.area_code) {
                var area: any = _.find(availableCities, {code: event.area_code});

                if (area) {
                  locationLabel = area.code == "OTHER" ? event.area_other : area.label;
                }
              }

              if (event.neighborhood_code) {
                var neighborhood: any = _.find(area.neighborhoods, {code: event.neighborhood_code});
                if (neighborhood) {
                  locationLabel += ", " + neighborhood.label;
                }
              }

              if (scope.params.showFullAddress && event.full_address) {
                locationLabel = event.full_address;
              }

              locationLabel = locationLabel || "";
              //if(event.my_reservation != null && event.my_reservation.state == 'accepted') {
              //  locationLabel = event.full_address;
              //}

              if(scope.params.limit != null && locationLabel.length > scope.params.limit) {
                scope.vm.infoParams.items[2].text = locationLabel.substr(0, scope.params.limit) + "...";
              } else {
                scope.vm.infoParams.items[2].text = locationLabel;
              }



              if (!event.secondary_address) {
                scope.vm.infoParams.items[3].visible = false;
              } else {
                scope.vm.infoParams.items[3].visible = true;
              }

              if (!scope.params.showSecondaryAddress) {
                scope.vm.infoParams.items[3].visible = false;
              }

              scope.vm.infoParams.items[3].icon = "icon-marker ot-grey-icon";

              //var location2Label = event.city;
              //if(event.my_reservation != null && event.my_reservation.state == 'accepted') {
              var location2Label = event.secondary_address || "";
              //}

              if(scope.params.limit != null && location2Label.length > scope.params.limit) {
                scope.vm.infoParams.items[3].text = location2Label.substr(0, scope.params.limit) + "...";
              } else {
                scope.vm.infoParams.items[3].text = location2Label;
              }
            }

            return scope.vm.infoParams;
          },
          isNear: (rawData) => {
            var d = SessionService.toDate(rawData, true);
            return SessionService.isToday(d) || SessionService.isTomorrow(d);
          },
          buildPrettyDate: (rawData) => {
            var d = SessionService.toDate(rawData, true);
            if (SessionService.isToday(d)) {
              return translateFilter("LANDING.TODAY");
            } else if (SessionService.isTomorrow(d)) {
              return translateFilter("LANDING.TOMORROW");
            } else {
              return dateFilter(d, "EEEE, MMMM d");
            }
          },
          buildPrettyHours: (rawDate, rawTime, duration) => {

            var dStart = SessionService.toDate(rawDate, true);
            var hrsMins = rawTime.split(":");
            dStart.setHours(parseInt(hrsMins[0]));
            dStart.setMinutes(parseInt(hrsMins[1]));
            var dEnd = new Date(dStart.getTime() + duration * 1000);

            if (isNaN(dStart.getTime()) || isNaN(dEnd.getTime())) {
              return "";
            }

            var startMinutes = dStart.getMinutes();
            var endMinutes = dEnd.getMinutes();

            var dateStartString = dateFilter(dStart, "h:mma").toLowerCase();
            var dateEndString = dateFilter(dEnd, "h:mma").toLowerCase();

            return dateStartString + " - " + dateEndString;
          }
        };
    }
  }

  static factory() {
    var tmp = (a, b) => new InfoDirective(a, b);
    tmp.$inject = ["$filter", "session"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/info.ts
 **/